import React, { FC, ReactNode } from 'react';
import { Box, Container, makeStyles, Theme, Typography } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import { MapLocationIcon } from 'svgs/projects';

interface ExploreAreasSectionProps {
  text: string;
  orangeText: string;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      margin: theme.spacing(10, 0, 15),
      textAlign: 'center',
      [theme.breakpoints.up('md')]: {
        margin: theme.spacing(15, 0, 15),
      },
    },
    text: {
      marginTop: theme.spacing(6),
      margin: '0 auto',
      maxWidth: 915,
      fontWeight: 500,
    },
    orangeText: {
      color: theme.palette.primary.main,
    },
  });
});

const ExploreAreasSection: FC<ExploreAreasSectionProps> = ({ text, orangeText }) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Container fixed>
        <MapLocationIcon />
        <Typography variant="h3" className={classes.text} data-aos="fade-up">
          <span className={classes.orangeText} id={'mapSection'}>
            {orangeText}
          </span>
          {text}
        </Typography>
      </Container>
    </Box>
  );
};

export default ExploreAreasSection;
